import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/styles/fonts.css';
import './index.css';
import App from './App';
import {store, persistor } from './store'
// Función para detectar problemas de estado de upgrade
const cleanupUpgradeState = () => {
  try {
    // Verificar si hay un upgrade state que podría estar causando problemas
    const upgradeState = localStorage.getItem('upgrade_state');
    if (upgradeState) {
      // Si el usuario no está autenticado y hay un estado de upgrade, limpiarlo
      const hasToken = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (!hasToken) {
        localStorage.removeItem('upgrade_state');
      } else {
        // Si el usuario está autenticado, verificar si el estado está obsoleto
        try {
          const state = JSON.parse(upgradeState);
          const now = Date.now();
          // Si el estado tiene más de 1 hora, considerarlo obsoleto
          if (state.startTime && (now - state.startTime > 60 * 60 * 1000)) {
            localStorage.removeItem('upgrade_state');
          }
        } catch (e) {
          // Si hay un error al parsear, limpiar
          localStorage.removeItem('upgrade_state');
        }
      }
    }
  } catch (e) {
    console.error('Error during cleanup:', e);
  }
};

// Ejecutar limpieza al inicio
cleanupUpgradeState();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
     <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
     </Provider>
  </React.StrictMode>
);